import React from "react";

function Buttons({ text, onClick }) {
  return (
    <button
      onClick={onClick}
      className="psych-btn"
    >
      {text}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14M12 5l7 7-7 7"/>
      </svg>
    </button>
  );
}

export default Buttons;
